import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { AdBuilder } from "../../AdBuilder/index.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const AdBuilderWrapper = ({
  entry,
  linkId,
  locale,
  children
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const entryId = (_c = (_b = (_a = entry == null ? void 0 : entry.background_foreground_banner_group) == null ? void 0 : _a.background_banner_reference) == null ? void 0 : _b[0]) == null ? void 0 : _c.uid;
  const enableBackgroundForegroundBanner = entry == null ? void 0 : entry.enable_background_foreground_banner;
  const backgroundBannerImageAlignment = (_d = entry == null ? void 0 : entry.background_foreground_banner_group) == null ? void 0 : _d.background_banner_image_alignment;
  const backgroundBannerButtonAlignment = (_e = entry == null ? void 0 : entry.background_foreground_banner_group) == null ? void 0 : _e.background_banner_button_alignment;
  const titleComponent = enableBackgroundForegroundBanner ? "h2" : void 0;
  if (entryId && enableBackgroundForegroundBanner) {
    return /* @__PURE__ */ jsxs(
      AdBuilder,
      {
        backgroundBannerButtonAlignment,
        backgroundBannerImageAlignment,
        entryId,
        locale,
        shouldLinkWrapButtonOnly: true,
        titleComponent,
        children: [
          /* @__PURE__ */ jsx(
            CostcoBox,
            {
              sx: {
                display: "flex",
                flexWrap: "wrap",
                gap: 4,
                marginBottom: 2,
                marginTop: 2,
                width: "100%"
              },
              children: (_g = (_f = entry == null ? void 0 : entry.background_foreground_banner_group) == null ? void 0 : _f.foreground_banner_group) == null ? void 0 : _g.map(
                ({ foreground_banner_reference }, index) => {
                  var _a2;
                  if (!(foreground_banner_reference == null ? void 0 : foreground_banner_reference.length) || !((_a2 = foreground_banner_reference[0]) == null ? void 0 : _a2.uid)) {
                    return null;
                  }
                  return /* @__PURE__ */ jsx(
                    AdBuilder,
                    {
                      entryId: foreground_banner_reference[0].uid,
                      isInsideCampaignSlider: true,
                      linkId,
                      locale
                    },
                    `foreground_banner_${index}`
                  );
                }
              )
            }
          ),
          children
        ]
      }
    );
  } else {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
};
export {
  AdBuilderWrapper
};
